import { useState, useCallback } from 'react';
import type { TourStep } from '@/components/ui/product-tour';

export function useLocationsTour() {
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [hasCompletedTour, setHasCompletedTour] = useState(() => {
    return localStorage.getItem('locations-tour-completed') === 'true';
  });

  const tourSteps: TourStep[] = [
    {
      target: '[data-tour="locations-header"]',
      title: 'Welcome to Locations',
      content: 'Manage physical locations and sub-locations where your assets are stored. Organize your assets by building, floor, room, or any hierarchy that suits your needs.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="locations-search"]',
      title: 'Search Locations',
      content: 'Quickly find locations by name or code using the search bar.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="locations-new-button"]',
      title: 'Create New Location',
      content: 'Click here to add a new location. You can create parent locations and sub-locations to build a hierarchical structure.',
      placement: 'left',
    },
    {
      target: '[data-tour="locations-table"]',
      title: 'Locations List',
      content: 'View all your locations with asset counts. Click the expand icon to view sub-locations. Click on a location name to view or edit its details.',
      placement: 'top',
    },
  ];

  const startTour = useCallback(() => {
    setIsTourOpen(true);
  }, []);

  const closeTour = useCallback(() => {
    setIsTourOpen(false);
  }, []);

  const completeTour = useCallback(() => {
    setIsTourOpen(false);
    setHasCompletedTour(true);
    localStorage.setItem('locations-tour-completed', 'true');
  }, []);

  const resetTour = useCallback(() => {
    setHasCompletedTour(false);
    localStorage.removeItem('locations-tour-completed');
  }, []);

  return {
    isTourOpen,
    tourSteps,
    startTour,
    closeTour,
    completeTour,
    resetTour,
    hasCompletedTour,
  };
}
